import { useState } from "react";
import { useUserDataContext } from "../../contexts/UserDataContext";
import { cognitoUserAttributes, useAccountContext } from "../../contexts/Account";
import {
  StyledButtonRow,
  StyledCancelWrapper,
  StyledInnerPopup_Small,
  StyledMoveOrUseContainer,
  StyledMoveOrUseSection,
  StyledOuterPopup,
  StyledMoveOrUseButton,
  StyledPopupTextArea,
} from "../../styles/components/Popup.styled";
import { useScrollLock } from "../../hooks";

export function SelectMoveOrUsePopup() {
  // Lock scrolling when modal is open
  useScrollLock(true);

  return (
    <StyledOuterPopup>
      <StyledInnerPopup_Small>
        <SelectMoveOrUse />
      </StyledInnerPopup_Small>
    </StyledOuterPopup>
  );
}

function SelectMoveOrUse() {
  const {
    setItemToMove,
    itemMap,
    itemToMoveOrUse,
    setItemToMoveOrUse,
    SaveItem,
    setMultiSelectMode,
    setSelectedItemsToMove,
    setIsLoading,
  } = useUserDataContext();
  const { userCognitoAttrubutes } = useAccountContext();
  const [inUseNote, setInUseNote] = useState(
    () => itemMap[itemToMoveOrUse]?.InUseNote ?? ""
  );

  function handleSaveError(error: any) {
    if (error === 0) {
      alert(
        "Error saving data. This issue can be a result of lost internet connection. Please check your connection and try again."
      );
    } else {
      alert(
        "Error saving data. Please try again and if the issue persists contact Admin@WheresOur.com. Error status = " +
          error
      );
    }
  }

  function OnMoveSelected() {
    setItemToMove(itemToMoveOrUse);
    setItemToMoveOrUse("");
  }

  function OnMoveMultipleSelected() {
    // Activate multi-select mode
    setMultiSelectMode(true);
    // Add the current item to selection
    setSelectedItemsToMove([itemToMoveOrUse]);
    // Close this modal
    setItemToMoveOrUse("");
  }

  function OnUseSelected(userId: string) {
    var itemData = itemMap[itemToMoveOrUse];
    const previousInUse = itemData.InUse;
    const previousInUseNote = itemData.InUseNote;
    itemData.InUse = !itemData.InUse;
    // Putting the item in use saves the note the user entered; returning it
    // clears the note automatically since it only describes current usage
    itemData.InUseNote = itemData.InUse ? inUseNote.trim() || undefined : undefined;
    setIsLoading("Saving...");
    SaveItem(itemData, "", true, "", userId, false)
      .then((res) => {
        setItemToMoveOrUse("");
      })
      .catch((error) => {
        itemData.InUse = previousInUse; //Set in use flag back
        itemData.InUseNote = previousInUseNote;
        handleSaveError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function OnUpdateNoteSelected(userId: string) {
    var itemData = itemMap[itemToMoveOrUse];
    const previousInUseNote = itemData.InUseNote;
    itemData.InUseNote = inUseNote.trim() || undefined;
    setIsLoading("Saving...");
    SaveItem(itemData, "", true, "", userId, false)
      .then(() => {
        setItemToMoveOrUse("");
      })
      .catch((error) => {
        itemData.InUseNote = previousInUseNote;
        handleSaveError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <div>
      <StyledMoveOrUseContainer>
        <StyledMoveOrUseSection>
          <h2>Move Item to Another Location:</h2>
          <StyledMoveOrUseButton onClick={OnMoveSelected}>
            Click To Move Item
          </StyledMoveOrUseButton>
          <StyledMoveOrUseButton onClick={OnMoveMultipleSelected}>
            Click To Move Multiple Items
          </StyledMoveOrUseButton>
        </StyledMoveOrUseSection>
        <StyledMoveOrUseSection>
          <h2>Toggle 'InUse' status: </h2>
          <StyledPopupTextArea
            placeholder="In Use Description (Optional)"
            maxLength={250}
            value={inUseNote}
            onChange={(e) => setInUseNote(e.target.value)}
          />
          <StyledButtonRow>
            {itemMap[itemToMoveOrUse].InUse && (
              <StyledMoveOrUseButton
                onClick={() =>
                  OnUpdateNoteSelected(
                    (userCognitoAttrubutes as cognitoUserAttributes).sub!
                  )
                }
              >
                Update Note
              </StyledMoveOrUseButton>
            )}
            <StyledMoveOrUseButton
              onClick={() =>
                OnUseSelected(
                  (userCognitoAttrubutes as cognitoUserAttributes).sub!
                )
              }
            >
              {itemMap[itemToMoveOrUse].InUse ? "Return Item" : "Put Item In Use"}
            </StyledMoveOrUseButton>
          </StyledButtonRow>
        </StyledMoveOrUseSection>
      </StyledMoveOrUseContainer>
      <StyledCancelWrapper>
        <StyledMoveOrUseButton onClick={() => setItemToMoveOrUse("")}>
          Cancel
        </StyledMoveOrUseButton>
      </StyledCancelWrapper>
    </div>
  );
}

export default SelectMoveOrUse;
